import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { Dropdown } from 'primereact/dropdown';
import { useAuth } from '../../../context/useAuth';
import api from '../../../services/apiIdz';


// CSS
import "./NewVidros.scss";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';

function NewVidros({ showVidros, handleAlert }) {

    const { token } = useAuth()
    const [showModalVidros, setShowModalVidros] = useState(false);

    const handleClose = () => {
        setShowModalVidros(false);
    };

    useEffect(() => {
        if (showVidros) {
            setShowModalVidros(true);
        }
    }, [showVidros]);

    const [popupData, setPopupData] = useState({
        opcoes: '',
        atributo:  ''
    })


    const handlePopupData = (value, field) => {
        setPopupData({
            ...popupData,
            [field]: value
        })
    }

    const postVidros = async () => {
        const dataToSend = {
            ...popupData,
            opcoes: [popupData.opcoes],
            atributo: 'tipo_vidro'
        };
       await api.post(`/api/atributos`, dataToSend, {
            headers: {
                'Authorization': process.env.REACT_APP_API_KEY,
                "Token": token
            }
        }).then(r => {
            console.log(r)

            if (typeof r.data == 'string') {
                handleAlert("Campos inválidos", r.data, "danger")
            } else {
                if (r.status == 200) {
                    handleAlert("Sucesso", "Os dados foram cadastrados com êxito.", "success")
                    handleClose()
                }
            }
        })
    }

    return (
        <>

            <Modal show={showModalVidros} className="NewModelo">
                <Modal.Header >
                    <Modal.Title>Cadastro de Vidros</Modal.Title>
                    <Icon icon="ri:edit-fill"></Icon>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nome do Vidro</Form.Label>
                            <Form.Control value={popupData["opcoes"]} onChange={(e) => { handlePopupData(e.target.value, "opcoes") }} type="text" placeholder="Informe o tipo do vidro" ></Form.Control>
                        </Form.Group>
                        <Form.Group className="text-center">
                            <Button variant="primary" className="Btns ButtonPrimaryLight" onClick={postVidros}>
                                Salvar
                            </Button>
                        </Form.Group>
                        <Form.Group className="text-center">
                            <Button variant="secondary" className="Btns ButtonLight" onClick={handleClose}>
                                Fechar
                            </Button>
                        </Form.Group>
                    </Form>
                </Modal.Body>
            </Modal>
            
        </>
    );
};

export default NewVidros;
